export default __webpack_public_path__ + "static/media/ino-whitepaper.569618ca.pdf";